import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

var _dec, _class;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { browserHistory } from 'react-router';
import { connect } from 'react-redux';
import Helmet from 'react-helmet';
import { getFBAdPreviewSrc } from 'redux/modules/adBuilder';
import { clearSettings, saveReport } from 'redux/modules/reportBuilder';
import { clearUpcomingContentTemplate, updateContentField, updateContentSectionRadio } from 'redux/modules/reportUpcomingContent';
import { clearFBChecklistTemplate, updateFBChecklistField } from 'redux/modules/reportFacebookChecklist';
import { clearTemplate, toggleAutoNextStep, toggleShowPromotedPosts, toggleSection, updateField, updateTextField } from 'redux/modules/reportSocialMediaSummary';
import { RadioButton, RadioButtonGroup } from 'material-ui/RadioButton';
import RaisedButton from 'material-ui/RaisedButton';
import TextField from 'material-ui/TextField';
import Toggle from 'material-ui/Toggle';
import Checkbox from 'material-ui/Checkbox';
import { ListItem } from 'material-ui/List';
import { LeftNavLayout } from 'containers';
import { Accordion, Dotdotdot, PageHeader, Spinner } from 'components';
import * as styles from './ReportBuilder.scss';
var Builder = (_dec = connect(function (state) {
  return {
    theme: state.theme,
    organization: state.organization.current,
    user: state.auth.user,
    settings: state.reportBuilder,
    savingReport: state.reportBuilder.savingReport,
    socialMediaSummaryTemplate: state.reportSocialMediaSummary,
    facebookChecklistTemplate: state.reportFacebookChecklist,
    upcomingContentTemplate: state.reportUpcomingContent
  };
}, {
  clearFBChecklistTemplate: clearFBChecklistTemplate,
  clearUpcomingContentTemplate: clearUpcomingContentTemplate,
  clearTemplate: clearTemplate,
  clearSettings: clearSettings,
  getFBAdPreviewSrc: getFBAdPreviewSrc,
  saveReport: saveReport,
  toggleAutoNextStep: toggleAutoNextStep,
  toggleSection: toggleSection,
  toggleShowPromotedPosts: toggleShowPromotedPosts,
  updateContentField: updateContentField,
  updateField: updateField,
  updateTextField: updateTextField,
  updateFBChecklistField: updateFBChecklistField,
  updateContentSectionRadio: updateContentSectionRadio
}), _dec(_class = /*#__PURE__*/function (_Component) {
  _inherits(Builder, _Component);

  var _super = _createSuper(Builder);

  function Builder(props) {
    var _this;

    _classCallCheck(this, Builder);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "renderSummaryField", function (template, sectionKey, field, index) {
      return /*#__PURE__*/React.createElement("div", {
        className: "".concat(styles.listItem, " ").concat(sectionKey === 'nextSteps' ? styles.nextStepsListItem : ''),
        key: field.key
      }, /*#__PURE__*/React.createElement(Checkbox, {
        label: field.label.slice(0, 4) === 'act_' ? "Promoted Post - ".concat(moment(field.data.campaign.start_time).format('MM/DD/YYYY')) : field.label,
        checked: field.value,
        onCheck: function onCheck(e, value) {
          var newValue = !field.value;

          if (sectionKey === 'recentPosts') {
            _this.props.getFBAdPreviewSrc(_this.props.orgId, _this.props.orgSocialAccountId, 'DESKTOP_FEED_STANDARD', {
              postId: field.key
            }); //            this.props.updateField(sectionKey, value, true, true);

          }

          _this.props.updateField(sectionKey, field.key, newValue);
        }
      }), sectionKey === 'nextSteps' && field.canBeAuto && /*#__PURE__*/React.createElement("div", {
        style: {
          display: 'flex',
          alignItems: 'center'
        }
      }, /*#__PURE__*/React.createElement(Toggle, {
        label: "Automatic",
        toggled: field.auto,
        onToggle: function onToggle() {
          _this.props.toggleAutoNextStep(field.key, !field.auto);
        },
        style: {
          marginTop: 8,
          marginBottom: 8,
          maxWidth: 125
        }
      }), field.auto && /*#__PURE__*/React.createElement("i", {
        className: "fa fa-refresh ".concat(styles.refreshIcon),
        onClick: function onClick() {
          _this.props.toggleAutoNextStep(field.key, true);
        }
      })), sectionKey === 'nextSteps' && field.value && /*#__PURE__*/React.createElement("div", null, field.textFields.map(function (textField, index) {
        return /*#__PURE__*/React.createElement(TextField, {
          id: "".concat(sectionKey, "_").concat(field.key, "_").concat(index),
          key: "".concat(sectionKey, "_").concat(field.key, "_").concat(index),
          hintText: field.label.substring(0, field.label.length - 1),
          value: textField,
          onChange: function onChange(e) {
            return _this.props.updateTextField(sectionKey, field.key, index, e.target.value);
          },
          style: {
            width: '100%'
          }
        });
      })));
    });

    _defineProperty(_assertThisInitialized(_this), "renderFBChecklistSection", function (section) {
      var template = _this.props.facebookChecklistTemplate;
      return /*#__PURE__*/React.createElement("div", {
        style: {
          padding: 16
        }
      }, /*#__PURE__*/React.createElement("div", {
        className: styles.checklistData
      }, section.key === 'cover' || section.key === 'picture' ? /*#__PURE__*/React.createElement("img", {
        src: section.dataValue,
        style: section.key === 'cover' ? {
          width: '100%'
        } : {
          width: 50
        }
      }) : section.manualField ? /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("span", null, "This field needs to be manually checked on Facebook."), /*#__PURE__*/React.createElement(TextField, {
        id: "".concat(section.key, "_dataValueField"),
        key: "".concat(section.key, "_dataValueField"),
        hintText: "".concat(section.label, " value"),
        multiLine: true,
        value: section.dataValue,
        onChange: function onChange(e) {
          return _this.props.updateFBChecklistField(section.key, 'dataValue', e.target.value, _this.props.user);
        },
        style: {
          width: '100%',
          marginTop: 8
        }
      })) : /*#__PURE__*/React.createElement("span", {
        className: styles.checklistFbDataValue
      }, section.dataValue)), /*#__PURE__*/React.createElement(RadioButtonGroup, {
        className: styles.list,
        name: section.key,
        defaultSelected: 4,
        valueSelected: section.value,
        onChange: function onChange(event, value) {
          // load ad preview for this post
          _this.props.updateFBChecklistField(section.key, 'value', value, _this.props.user);
        }
      }, template.checklistOptions.map(function (o, index) {
        return /*#__PURE__*/React.createElement(RadioButton, {
          value: index,
          label: o.label,
          key: "".concat(o.key, "_").concat(index),
          style: {
            paddingTop: 8
          }
        });
      })), section.value === 3 && /*#__PURE__*/React.createElement(TextField, {
        id: "".concat(section.key, "_fbChecklist"),
        key: "".concat(section.key, "_fbChecklist"),
        hintText: "Feedback",
        value: section.feedback,
        onChange: function onChange(e) {
          return _this.props.updateFBChecklistField(section.key, 'feedback', e.target.value, _this.props.user);
        },
        style: {
          width: '100%',
          marginTop: 8
        }
      }), /*#__PURE__*/React.createElement("div", {
        className: styles.checklistCommentWrap
      }, /*#__PURE__*/React.createElement(TextField, {
        id: "".concat(section.key, "_fbChecklistComment"),
        key: "".concat(section.key, "_fbChecklistComment"),
        hintText: "Comments",
        value: section.comments,
        onChange: function onChange(e) {
          return _this.props.updateFBChecklistField(section.key, 'comments', e.target.value, _this.props.user);
        },
        style: {
          width: '100%',
          marginTop: 8
        }
      })));
    });

    _defineProperty(_assertThisInitialized(_this), "renderUpcomingContentSection", function (section) {
      var template = _this.props.upcomingContentTemplate;
      var showCustomPosts = template.postTypesToShow.find(function (t) {
        return t.key === 'customPosts';
      }).value;
      var showQueuedPosts = template.postTypesToShow.find(function (t) {
        return t.key === 'queuePosts';
      }).value;
      var filteredPosts = !showQueuedPosts ? template.posts.filter(function (post) {
        return !post.QueueId;
      }) : template.posts;
      filteredPosts = !showCustomPosts ? filteredPosts.filter(function (post) {
        return post.QueueId;
      }) : filteredPosts; // sort by publishAt to interweave custom and queue posts

      filteredPosts = _.sortBy(filteredPosts, function (o) {
        return new moment(o.publishAt);
      });
      return /*#__PURE__*/React.createElement("div", {
        style: {
          padding: 16
        }
      }, section.key === 'postTypesToShow' && /*#__PURE__*/React.createElement("div", null, template.postTypesToShow.map(function (field, index) {
        return /*#__PURE__*/React.createElement(Checkbox, {
          key: "postTypesToShow_".concat(index),
          label: field.label,
          checked: field.value,
          onCheck: function onCheck() {
            var newValue = !field.value;

            _this.props.updateContentField('postTypesToShow', field.key, newValue);
          }
        });
      })), section.key === 'posts' && /*#__PURE__*/React.createElement("div", null, filteredPosts.map(function (post, index) {
        return /*#__PURE__*/React.createElement(Checkbox, {
          style: {
            borderBottom: '1px solid #f1f1f1',
            paddingBottom: 6,
            marginBottom: 6
          },
          key: "postsToShow_".concat(index),
          label: post.message ? /*#__PURE__*/React.createElement(Dotdotdot, {
            clamp: 2
          }, "".concat(moment(post.publishAt).format('MM/DD/YYYY'), ": ").concat(post.message)) : post.linkUrl ? "".concat(moment(post.publishAt).format('MM/DD/YYYY'), ": Link Post") : moment(post.publishAt).format('MM/DD/YYYY'),
          checked: post.value,
          onCheck: function onCheck() {
            var newValue = !post.value;

            _this.props.updateContentField('posts', post.id, newValue);
          }
        });
      })), section.key === 'previewType' && /*#__PURE__*/React.createElement(RadioButtonGroup, {
        className: styles.list,
        name: section.key,
        defaultSelected: section.value,
        onChange: function onChange(event, value) {
          _this.props.updateContentSectionRadio('previewType', value);
        }
      }, template.previewType.map(function (o, index) {
        return /*#__PURE__*/React.createElement(RadioButton, {
          value: index,
          label: o.label,
          key: "previewTypeRadio_".concat(index),
          style: {
            paddingTop: 8
          }
        });
      })));
    });

    _defineProperty(_assertThisInitialized(_this), "renderSummarySection", function (section) {
      var template = _this.props.socialMediaSummaryTemplate;
      return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
        className: styles.sectionToggleWrap,
        style: section.key === 'adPerformance' ? {
          marginBottom: 0
        } : {}
      }, /*#__PURE__*/React.createElement(Toggle, {
        label: "Show ".concat(section.label),
        toggled: section.enabled,
        onToggle: function onToggle() {
          _this.props.toggleSection(section.key, !section.enabled);
        },
        style: {
          maxWidth: 250
        }
      })), section.key === 'adPerformance' && /*#__PURE__*/React.createElement("div", {
        className: styles.sectionToggleWrap
      }, /*#__PURE__*/React.createElement(Toggle, {
        label: "Show Promoted Posts",
        toggled: section.showPromotedPosts,
        onToggle: function onToggle() {
          _this.props.toggleShowPromotedPosts(!section.showPromotedPosts);

          if (_this.props.settings.selectedClient && template.adPerformance && !!template.adPerformance.length) {
            template.adPerformance.forEach(function (ad, index) {
              if (ad.data.name.slice(0, 4) === 'act_') {
                _this.props.getFBAdPreviewSrc(_this.props.settings.selectedClient.id, _this.props.settings.selectedClient.SocialAccountId, 'DESKTOP_FEED_STANDARD', {
                  adId: ad.data.id
                });
              }
            });
          }
        },
        style: {
          maxWidth: 250
        }
      })), section.enabled && template[section.key] && !!template[section.key].length && /*#__PURE__*/React.createElement("div", {
        style: section.key === 'nextSteps' ? {
          padding: 0,
          paddingBottom: 16
        } : {
          padding: '0 16px 16px'
        }
      }, /*#__PURE__*/React.createElement("div", {
        className: styles.list
      }, template[section.key].map(function (field) {
        if (section.key !== 'adPerformance') {
          return _this.renderSummaryField(template, section.key, field);
        } else if (section.showPromotedPosts && field.data.isPromotedPost || !field.data.isPromotedPost) {
          return _this.renderSummaryField(template, section.key, field);
        }

        return null;
      }))), !section.enabled && !template[section.key] && /*#__PURE__*/React.createElement("div", {
        style: {
          padding: 16,
          color: '#333333'
        }
      }, "No results for that date range."));
    });

    _this.state = {};
    return _this;
  }
  /** *******************************************************************************************
   RENDER
  ********************************************************************************************/


  _createClass(Builder, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var reportType = this.props.reportType;
      var fbChecklistTemplate = this.props.facebookChecklistTemplate;
      var upcomingContentTemplate = this.props.upcomingContentTemplate;
      var socialMediaSummaryTemplate = this.props.socialMediaSummaryTemplate;
      var fbChecklistAccordion = /*#__PURE__*/React.createElement(Accordion, {
        acccordionContentStyles: {
          padding: 0
        },
        style: {
          marginTop: 0
        },
        sections: this.props.facebookChecklistTemplate.sections.map(function (section, index) {
          return {
            id: "builderSection_".concat(index),
            label: section.label,
            content: _this2.renderFBChecklistSection(section)
          };
        })
      });
      var upcomingContentAccordion = /*#__PURE__*/React.createElement(Accordion, {
        acccordionContentStyles: {
          padding: 0
        },
        style: {
          marginTop: 0
        },
        sections: this.props.upcomingContentTemplate.sections.map(function (section, index) {
          return {
            id: "builderSection_".concat(index),
            label: section.label,
            content: _this2.renderUpcomingContentSection(section)
          };
        })
      });
      var socialMediaSummaryAccordion = /*#__PURE__*/React.createElement(Accordion, {
        acccordionContentStyles: {
          padding: 0
        },
        style: {
          marginTop: 0
        },
        sections: this.props.socialMediaSummaryTemplate.sections.map(function (section, index) {
          return {
            id: "builderSection_".concat(index),
            label: section.label,
            content: _this2.renderSummarySection(section)
          };
        })
      });
      return /*#__PURE__*/React.createElement("div", {
        style: {
          flex: '1 1 35%',
          overflow: 'auto',
          paddingLeft: 12,
          paddingBottom: 24
        }
      }, reportType === 'socialMediaSummary' && socialMediaSummaryAccordion, reportType === 'upcomingContent' && upcomingContentAccordion, reportType === 'facebookChecklist' && fbChecklistAccordion, /*#__PURE__*/React.createElement(RaisedButton, {
        label: reportType === 'socialMediaSummary' && (parseInt(socialMediaSummaryTemplate.gettingAdPreview, 10) > 0 || socialMediaSummaryTemplate.gettingAds) ? /*#__PURE__*/React.createElement("i", {
          className: "fa fa-spinner fa-spin",
          style: {
            fontSize: 20
          }
        }) : "".concat(this.props.reportId ? 'Save' : 'Build', " Report"),
        style: {
          marginTop: 24
        },
        secondary: true,
        onClick: function onClick() {
          var template = reportType === 'socialMediaSummary' ? socialMediaSummaryTemplate : reportType === 'upcomingContent' ? upcomingContentTemplate : fbChecklistTemplate;

          _this2.props.saveReport(template, _this2.props.settings, _this2.props.reportId, reportType).then(function (res) {
            browserHistory.push({
              pathname: "/global/report-builder/org/".concat(res.data.OrganizationId, "/report/").concat(res.data.id)
            });
          });
        },
        disabled: this.props.savingReport || reportType === 'socialMediaSummary' && (parseInt(socialMediaSummaryTemplate.gettingAdPreview, 10) > 0 || socialMediaSummaryTemplate.gettingAds)
      }), this.props.reportId && /*#__PURE__*/React.createElement(RaisedButton, {
        label: "Cancel",
        style: {
          marginTop: 24,
          marginLeft: 24
        },
        onClick: function onClick() {
          if (_this2.props.reportType === 'socialMediaSummary') {
            _this2.props.clearTemplate();
          } else if (_this2.props.reportType === 'facebookChecklist') {
            _this2.props.clearFBChecklistTemplate();
          } else if (_this2.props.reportType === 'upcomingContent') {
            _this2.props.clearUpcomingContentTemplate();
          }

          _this2.props.clearSettings();

          browserHistory.push({
            pathname: '/global/report-builder'
          });
        }
      }));
    }
  }]);

  return Builder;
}(Component)) || _class);
export { Builder as default };